export const GET_ALLSONGS_LOADING = 'GET_ALLSONGS_LOADING';
export const GET_ALLSONGS_SUCCESS = 'GET_ALLSONGS_SUCCESS';
export const GET_ALLSONGS_FAILURE = 'GET_ALLSONGS_FAILURE';


export const ADD_SONG_LOADING = 'ADD_SONG_LOADING';
export const ADD_SONG_SUCCESS = 'ADD_SONG_SUCCESS';
export const ADD_SONG_FAILURE = 'ADD_SONG_FAILURE';


export const GET_SONG_LOADING = 'GET_SONG_LOADING';
export const GET_SONG_SUCCESS = 'GET_SONG_SUCCESS';
export const GET_SONG_FAILURE = 'GET_SONG_FAILURE';


export const UPDATE_SONG_LOADING = 'UPDATE_SONG_LOADING';
export const UPDATE_SONG_SUCCESS = 'UPDATE_SONG_SUCCESS';
export const UPDATE_SONG_FAILURE = 'UPDATE_SONG_FAILURE';


export const DELETE_SONG_LOADING = 'DELETE_SONG_LOADING';
export const DELETE_SONG_SUCCESS = 'DELETE_SONG_SUCCESS';
export const DELETE_SONG_FAILURE = 'DELETE_SONG_FAILURE';